<svg-icon [name]="iconName" *ngIf="iconName"></svg-icon>

<div class="single" *ngIf="(singleText || breadcrumb) && !stackedTextTitle">
  <span class="body-1-semi-bold title" *ngIf="singleText">
    {{ singleText }}
  </span>
  <span class="body-1-medium breadcrumb" *ngIf="breadcrumb">{{ breadcrumb }}</span>
</div>
<div class="stacked-text" *ngIf="stackedTextTitle">
  <div class="title">
    <span class="body-1-semi-bold primary">{{ stackedTextTitle }}</span>
    <span class="body-1-medium breadcrumb" *ngIf="breadcrumb">{{ breadcrumb }}</span>
  </div>
  <span class="body-1-medium subtitle" *ngIf="stackedTextSubtitle">{{ stackedTextSubtitle }}</span>
</div>
